export const LeadTestID = {
    LEAD_FORM_SKELETON: 'lead-form-skeleton',
    LEAD_INFO_FORM: 'lead-info-form',
    LEAD_SUCCESS: 'lead-success',
    LEAD_ERROR: 'lead-error',
    LEAD_SMS_CONFIRM: 'lead-sms-confirm',
};
